import { render } from "./TheAposContextBar.vue?vue&type=template&id=25305958&scoped=true"
import script from "./TheAposContextBar.vue?vue&type=script&lang=js"
export * from "./TheAposContextBar.vue?vue&type=script&lang=js"

import "./TheAposContextBar.vue?vue&type=style&index=0&id=25305958&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25305958"],['__file',"admin-bar/ui/apos/components/TheAposContextBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25305958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25305958', __exports__)) {
    api.reload('25305958', __exports__)
  }
  
  module.hot.accept("./TheAposContextBar.vue?vue&type=template&id=25305958&scoped=true", () => {
    api.rerender('25305958', render)
  })

}


export default __exports__